import { Box } from "@material-ui/core";

export interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

export const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;
  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      {...other}
      width={"100%"}
    >
      <Box>{children}</Box>
    </Box>
  );
};
